// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2028":"82437168","2194":"25a84c9e","3855":"f4e495ce","4774":"33eaaa1b","5474":"3fcda386","6427":"a08eb156","6624":"9c58b10d","7541":"b28a28ab","8116":"163777db","9902":"a02870e2"}[chunkId] + ".chunk.css";
};